import { render, staticRenderFns } from "./IngredientCard.vue?vue&type=template&id=31fb9cd3&scoped=true&"
import script from "./IngredientCard.vue?vue&type=script&lang=js&"
export * from "./IngredientCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb9cd3",
  null
  
)

export default component.exports